module.exports = __webpack_public_path__ + "img/img-header.2c7cd77.webp";